import { useOnDeleteUser } from '../../hooks/useOnDeleteUser'
import { useOnEditUser } from '../../hooks/useOnEditUser'

export function useActions() {
  return {
    onEditUser: useOnEditUser(),
    onDeleteUser: useOnDeleteUser(),
  }
}
